import React from "react";
import Footer from "../Components/Footer/Footer";
import Login from "../Components/Login/Login";
import LoginTopBar from "../Components/LoginTopBar/LoginTopBar";

const CustomerLogin = () => {
  return (
    <>
      <LoginTopBar />

      <Login />
      {/* <Footer /> */}
    </>
  );
};

export default CustomerLogin;
